module.exports = __webpack_public_path__ + "img/24.6a231321.png";